import React from 'react'
import { isEmpty } from 'lodash'
import { Card, CardBody, CardFooter } from 'reactstrap'
import ApiService from '../../../data/services/ApiService'
import { getUrlOfDefaultProductImage } from '../../../helpers/utils'

const routeSuppliersStorage = 'suppliers/'

const SupplierLogo = ({
  supplier,
  shareButtonAction,
}) => {
  return (
    <React.Fragment>
      <Card>
        <CardBody style={{ alignSelf: 'center' }}>
          <div
            className="rounded rounded-circle text-center"
            style={{ height: 135, width: 140, border: '1px solid #cccccc' }}
          >
            <img
              className="avatar-lg"
              src={!isEmpty(supplier.logotipo) ? `${ApiService.getUrlBaseStorage()}${routeSuppliersStorage}${supplier.logotipo}` : getUrlOfDefaultProductImage()}
              alt=""
              style={{ objectFit: 'contain', marginTop: '20px' }}
              width={150}
            />
          </div>
        </CardBody>
        <CardFooter className="bg-transparent border-top">
          <div className="contact-links d-flex font-size-20">
            <div className="flex-fill text-right">
              <button
                onClick={shareButtonAction}
                target={`_blank`}
                className={`btn btn-whatsapp`}
              >
                <i className="bx bxl-whatsapp"></i> Compartir
              </button>
            </div>
          </div>
        </CardFooter>
      </Card>
    </React.Fragment>
  )
}

export default SupplierLogo
